/*
 * lvh-site.js: motion and the cart free-shipping bar, loaded on every page by
 * sections/lvh-site.liquid.
 *
 * Everything here is an enhancement. With JS off, or with "reduce motion" on,
 * content renders exactly as the CSS lays it out: reveal classes are only
 * added by this script, and only to elements that start below the fold.
 */
(function () {
  var tag = document.querySelector('script[data-lvh-site]');
  var cfg = {
    motion: !tag || tag.dataset.motion !== 'false',
    threshold: tag ? parseFloat(tag.dataset.shipThreshold) || 0 : 0,
    currency: tag ? tag.dataset.shipCurrency || 'USD' : 'USD'
  };
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var animate = cfg.motion && !reduce && 'IntersectionObserver' in window;

  /* ── reveal on scroll ─────────────────────────────────── */
  // Groups of siblings reveal one after another (see --lvh-i in the CSS).
  var REVEAL = [
    '.lvh .lvh-head', '.lvh-who > a', '.lvh-pcard', '.lvh-bundle', '.lvh-finding',
    '.lvh-meetings', '.lvh-doc > *', '.lvh-member', '.lvh-access .grid > *',
    '.lvh-guide', '.lvh-news', '.lvh-promise', '.lvh-pro .inner',
    '[class^="why-matters__heading-"]', '[class^="why-matters__stat-template"]',
    '[class^="the-science__heading-"]', '[class^="the-science__benefit-template"]', '[class^="the-science__media-template"]',
    '[class^="studies__heading-"]', '[class^="studies__card-template"]',
    '[class^="related-prod__heading-"]', '[class^="related-prod__card-template"]',
    '[class^="faq__heading-"]', '[class^="collection-page__card-template"]'
  ].join(',');

  function setupReveal() {
    var fold = window.innerHeight * 0.92;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('lvh-in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    var seen = new Map();
    document.querySelectorAll(REVEAL).forEach(function (el) {
      if (el.getBoundingClientRect().top < fold) return; // already on screen: leave it alone
      var parent = el.parentElement;
      var i = seen.get(parent) || 0;
      seen.set(parent, i + 1);
      el.style.setProperty('--lvh-i', Math.min(i, 6));
      el.classList.add('lvh-rv');
      io.observe(el);
    });
  }

  /* ── numbers count up ─────────────────────────────────── */
  function setupCount() {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        var node = e.target.firstChild;
        var m = node.nodeValue.match(/^(\d+)(.*)$/);
        var end = parseInt(m[1], 10), suffix = m[2];
        var t0 = null;
        function step(t) {
          if (t0 === null) t0 = t;
          var p = Math.min((t - t0) / 1100, 1);
          node.nodeValue = Math.round(end * (1 - Math.pow(1 - p, 3))) + suffix;
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.6 });

    // Homepage number band, plus About hero stats like "100%". Zero is left alone.
    document.querySelectorAll('.lvh-fact .n, [class*="about-hero__stat-num"]').forEach(function (n) {
      var node = n.firstChild;
      if (!node || node.nodeType !== 3 || !/^\s*[1-9]\d*%?\s*$/.test(node.nodeValue)) return;
      node.nodeValue = node.nodeValue.trim();
      io.observe(n);
    });
  }

  /* ── hero tubes follow the pointer ────────────────────── */
  function setupParallax() {
    if (!window.matchMedia('(pointer: fine)').matches) return;
    document.querySelectorAll('.lvh-art').forEach(function (art) {
      var raf = 0;
      art.addEventListener('pointermove', function (ev) {
        var r = art.getBoundingClientRect();
        var x = (ev.clientX - r.left) / r.width - 0.5;
        var y = (ev.clientY - r.top) / r.height - 0.5;
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          art.style.setProperty('--mx', x.toFixed(3));
          art.style.setProperty('--my', y.toFixed(3));
        });
      });
      art.addEventListener('pointerleave', function () {
        art.style.setProperty('--mx', 0);
        art.style.setProperty('--my', 0);
      });
    });
  }

  /* ── header shadow once the page scrolls ──────────────── */
  function setupHeader() {
    var on = false;
    function check() {
      var next = window.scrollY > 8;
      if (next !== on) { on = next; document.documentElement.classList.toggle('lvh-scrolled', on); }
    }
    window.addEventListener('scroll', check, { passive: true });
    check();
  }

  /* ── cart drawer: free-shipping progress ──────────────── */
  function money(cents) { return '$' + (cents / 100).toFixed(2).replace(/\.00$/, ''); }

  function setupShipBar() {
    if (!cfg.threshold) return;
    var drawer = document.querySelector('#mini-cart');
    var content = drawer && drawer.querySelector('.js-ajax-cart-content');
    var header = drawer && drawer.querySelector('.ajax-cart__header-wrapper');
    if (!content || !header) return;

    var bar = document.createElement('div');
    bar.className = 'lvh-ship';
    bar.setAttribute('role', 'status');
    bar.hidden = true;
    bar.innerHTML = '<p class="lvh-ship__msg"></p><div class="lvh-ship__track"><span class="lvh-ship__fill"></span></div>';
    header.insertAdjacentElement('afterend', bar);
    var msg = bar.querySelector('.lvh-ship__msg');
    var fill = bar.querySelector('.lvh-ship__fill');
    var goal = Math.round(cfg.threshold * 100);

    var pending = 0;
    function refresh() {
      clearTimeout(pending);
      pending = setTimeout(function () {
        fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            if (!cart.item_count || cart.currency !== cfg.currency) { bar.hidden = true; return; }
            var left = goal - cart.total_price;
            bar.hidden = false;
            bar.classList.toggle('is-done', left <= 0);
            msg.textContent = left <= 0
              ? 'Free shipping unlocked.'
              : 'You’re ' + money(left) + ' away from free shipping.';
            fill.style.width = Math.min(100, (cart.total_price / goal) * 100) + '%';
          })
          .catch(function () { bar.hidden = true; });
      }, 150);
    }
    new MutationObserver(refresh).observe(content, { childList: true, subtree: true });
    refresh();
  }

  function init() {
    document.documentElement.classList.add('lvh-js');
    setupHeader();
    setupShipBar();
    if (!animate) return;
    document.documentElement.classList.add('lvh-motion');
    setupReveal();
    setupCount();
    setupParallax();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
